import { defineStore } from 'pinia'
import { store } from '../index'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import th from 'element-plus/es/locale/lang/th'
import km from 'element-plus/es/locale/lang/km'
import id from 'element-plus/es/locale/lang/id'
import es from 'element-plus/es/locale/lang/es'
import kk from 'element-plus/es/locale/lang/kk'
import ru from 'element-plus/es/locale/lang/ru'
import lo from 'element-plus/es/locale/lang/lo'
import fr from 'element-plus/es/locale/lang/fr'
import sw from 'element-plus/es/locale/lang/sw'
import uzUz from 'element-plus/es/locale/lang/uz-uz'
import vi from 'element-plus/es/locale/lang/vi'
import { useStorage } from '@/hooks/web/useStorage'
import { LocaleDropdownType } from '@/components/LocaleDropdown'

const { getStorage, setStorage } = useStorage('localStorage')

const elLocaleMap = {
  'zh-CN': zhCn,
  en: en,
  th: th,
  km: km,
  id: id,
  es: es,
  kk: kk,
  ru: ru,
  lo: lo,
  fr: fr,
  sw: sw,
  uz: uzUz,
  vi: vi
}

// 获取浏览器当前语言，获取失败或者代码不支持时返回 zh-CN
export function getBrowserLanguage(): string {
  try {
    const nav: any = typeof navigator !== 'undefined' ? navigator : undefined
    if (nav) {
      const fromList = Array.isArray(nav.languages) && nav.languages.length ? nav.languages[0] : undefined
      const raw = fromList || nav.language || nav.browserLanguage || nav.userLanguage
      if (typeof raw === 'string' && raw) {
        return raw.replace('_', '-')
      }
    }
  } catch (e) {
    // ignore
  }
  return 'zh-CN'
}
interface LocaleState {
  currentLocale: LocaleDropdownType
  localeMap: LocaleDropdownType[]
}

export const useLocaleStore = defineStore('locales', {
  state: (): LocaleState => {
    // 先定义支持的语言列表
    const localeMap: LocaleDropdownType[] = [
      {
        lang: 'zh-CN',
        name: '简体中文'
      },
      {
        lang: 'en',
        name: 'English'
      },
      {
        lang: 'th',
        name: 'ภาษาไทย'
      },
      {
        lang: 'km',
        name: 'ខ្មែរ'
      },      
      {
        lang: 'id',
        name: 'bahasa Indo'
      },
      {
        lang: 'es',
        name: 'Español'
      },
      {
        lang: 'ru',
        name: 'Русский'
      },
      {
        lang: 'kk',
        name: 'Қазақша'
      },
      {
        lang: 'lo',
        name: 'ພາສາລາວ'
      },
      {
        lang: 'fr',
        name: 'Français'
      },
      {
        lang: 'sw',
        name: 'Kiswahili'
      },
      {
        lang: 'uz',
        name: 'Ozbekcha'
      },
      {
        lang: 'vi',
        name: 'Tiếng Việt'
      }
    ]

    // 从本地存储或浏览器获取候选语言
    const candidateLang: any = (getStorage('lang') as string) || getBrowserLanguage() || 'zh-CN'
    // 只按连字符前的主语言匹配（例如 en-US -> en），未命中则回退 zh-CN
    const primary = String(candidateLang).toLowerCase().split('-')[0]
    const match = localeMap.find((v) => v.lang.toLowerCase().split('-')[0] === primary)
    const finalLang = match ? match.lang : 'zh-CN'

    return {
      currentLocale: {
        lang: finalLang,
        elLocale: elLocaleMap[finalLang] || zhCn
      },
      // 多语言
      localeMap
    }
  },
  getters: {
    getCurrentLocale(): LocaleDropdownType {
      return this.currentLocale
    },
    getLocaleMap(): LocaleDropdownType[] {
      return this.localeMap
    }
  },
  actions: {
    setCurrentLocale(localeMap: LocaleDropdownType) {
      // this.locale = Object.assign(this.locale, localeMap)
      this.currentLocale.lang = localeMap?.lang
      this.currentLocale.elLocale = elLocaleMap[localeMap?.lang] || zhCn
      setStorage('lang', localeMap?.lang)
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'store_locale',
        storage: localStorage
      }
    ]
  }
})

export const useLocaleStoreWithOut = () => {
  return useLocaleStore(store)
}
